<h1 class="flex justify-between">
    <span>Reopen Application</span><span>School Year: <span>{{ schoolYear | schoolYear }}</span></span>
</h1>
<mat-divider></mat-divider>

<p>
    This tool is for letting a student change their application when they
    otherwise wouldn't be able to. If a student has already submitted and
    finalized their application and the deadline has not passed yet, this tool
    will set their application status to incomplete and let them change their
    application and resubmit it before the deadline passes. If they do not submit
    their application again, their application will be listed as incomplete.
    There is no automatic submission if they take no action.
</p>
<p>
    If the deadline has already passed, this tool can give them special privileges and let them
    change their application just like the previous option, but they must make
    their changes before the applications are sent off to the scholarship givers.
</p>
<p>
    <strong>
        Therefore, this tool must only be used in special cases with all
        parties knowing the circumstances and using your own judgement.
    </strong>
</p>
<form class="flex flex-col w-[200px] mt-[50px] ml-[50px]" #form="ngForm" (ngSubmit)="search(form)" novalidate>
    <mat-form-field>
        <mat-label>Student ID</mat-label>
        <input matInput ngModel name="studentID" #studentID="ngModel" required />
        @if (studentID.errors?.['required']) {
        <mat-error>response required</mat-error>
        }
    </mat-form-field>
    <button mat-raised-button type="submit">Search</button>
</form>
@if (student == null && form.submitted && delay === false) {
<div class="w-fit text-red-500 mt-[30px] mb-0 mx-auto">
    No Application Found for that StudentID
</div>
}
<form [formGroup]="reopenForm" (ngSubmit)="submit(reopenForm)">
    @if (student != null) {
    <mat-card class="flex flex-col my-[20px] mx-0 p-[20px]">
        <div>
            <strong class="inline-block w-[200px] my-[10px] mr-[20px] mb-0 text-right">Student Name:</strong>
            <span>{{ student.StudentName }}</span>
        </div>
        <div>
            <strong class="inline-block w-[200px] my-[10px] mr-[20px] mb-0 text-right">Student ID:</strong>
            <span>{{ student.StudentID }}</span>
        </div>
        <div>
            <strong class="inline-block w-[200px] my-[10px] mr-[20px] mb-0 text-right">School:</strong>
            <span>{{ student.SchoolInfo }}</span>
        </div>
        <div>
            <strong class="inline-block w-[200px] my-[10px] mr-[20px] mb-0 text-right">Application Status:</strong>
            <span>{{ student.Status }}</span>
        </div>
        <div>
            <strong class="inline-block w-[200px] my-[10px] mr-[20px] mb-0 text-right">Disqualified:</strong>
            <span>{{ student.Disqualified ? "Yes" : "No" }}</span>
        </div>
        <div>
            <strong class="inline-block w-[200px] my-[10px] mr-[20px] mb-0 text-right">Authorized By:</strong>
            <mat-form-field class="w-[500px]">
                <input matInput formControlName="AuthorizedBy" required maxlength="200" />
                @if (reopenForm.get('AuthorizedBy').hasError('required')) {
                <mat-error>response required</mat-error>
                }
            </mat-form-field>
        </div>
        <div>
            <strong class="inline-block w-[200px] my-[10px] mr-[20px] mb-0 text-right">Reason:</strong>
            <mat-form-field class="w-[500px]" appearance="outline">
                <textarea matInput formControlName="Reason" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="1000" #reason></textarea>
                <mat-hint align="end">{{ reason.value.length }}/1000</mat-hint>
                @if (reopenForm.get('Reason').hasError('required')) {
                <mat-error>response required</mat-error>
                }
            </mat-form-field>
        </div>

        <div class="ml-[50px]">
            @if (pastDeadline === true) {
            <p>
                The deadline for applying to scholarships was
                {{ deadline | date : "MMM d y h:mmaaa" }}. The student must make
                changes ASAP so they can be in the applicant list before the
                applications are sent out.
            </p>
            }
            @else {
            <p>
                The deadline for applying to scholarships is
                {{ deadline | date : "MMM d y h:mmaaa" }}. The student will have
                until this time to make changes and resubmit their application.
            </p>
            <p>
                If they do not submit their application again, their application will be listed as incomplete.
                There is no automatic submission if they take no action.
            </p>
            }
            <button mat-raised-button type="submit" [disabled]="student.Status === 'Incomplete'">
                Submit
            </button>
        </div>
    </mat-card>
    }
</form>